import { TextField } from '@mui/material';
import { useLanguage } from '../../../../../context/LanguageContext';
import { useSyncedInputValue } from './useSyncedInputValue';

interface NumberEditorProps {
    value: string | number;
    onChange: (value: string) => void;
}

function NumberEditor({ value, onChange }: NumberEditorProps) {
    const { t } = useLanguage();
    const strValue = value ? String(value) : '';
    const inputRef = useSyncedInputValue(strValue);

    return (
        <TextField
            inputRef={inputRef}
            type="number"
            size="small"
            fullWidth
            defaultValue={strValue}
            onBlur={(e) => onChange(e.target.value)}
            placeholder={t('pages.clients.queryBuilder.simple.numberPlaceholder')}
        />
    );
}

export default NumberEditor;
